import { Vec3 } from 'ayvri-std/lib/vector';

class Playhead {
  _trackId = undefined;
  _point = undefined;
  _cartesian = undefined;
  _courseDistance = undefined;

  constructor(trackId) {
    this._trackId = trackId;
  }

  update(time, track, course) {
    // Find the current point along the track
    const result = { x: 0.0, y: 0.0, z: 0.0, cumulative: 0.0 };
    this._point = track.sampleLinear({ time }, result);

    // Package up the cartesian properties for ease of use
    this._cartesian = new Vec3(result.x, result.y, result.z);

    // If this scene has a course, sample it
    this._courseDistance = this._point ? course.sampleDistance(this._trackId, this._cartesian, result.cumulative) : 0.0;
  }

  get ready() {
    return this._point !== undefined;
  }

  get trackId() {
    return this._trackId;
  }
  get cumulative() {
    return this._point ? this._point.cumulative : undefined;
  }
  get cartesian() {
    return this._cartesian;
  }

  get courseDistance() {
    return this._courseDistance;
  }
}

export class PlayheadCollection {
  _store;
  _heads = {};

  constructor(store) {
    this._store = store;
  }

  addPlayhead(options) {
    console.assert(options.trackId);
    const head = new Playhead(options.trackId);
    this._heads[options.trackId] = head;

    // Keep some playhead information in State
    this._store.dispatch({
      type: 'ADD_PLAYHEAD',
      id: options.trackId,
      playhead: head,
    });
  }

  removePlayhead(id) {
    delete this._heads[id];
    this._store.dispatch({
      type: 'REMOVE_PLAYHEAD',
      id,
    });
  }

  get(playheadId) {
    return this._heads[playheadId];
  }

  update(time, tracks, course) {
    // Interpolate a new point along the track for each playhead
    Object.keys(this._heads).forEach(headId => {
      const head = this._heads[headId];
      const track = tracks.getTrack(head.trackId);
      head.update(time, track, course);
    });

    this._store.dispatch({
      type: 'SET_PLAYHEAD_POINTS',
      heads: this._heads,
    });
  }
}

export function playheadsReducer(state = {}, action = {}) {
  switch (action.type) {
    case 'ADD_PLAYHEAD': {
      const newState = Object.assign({}, state);
      newState[action.id] = action.playhead;
      return newState;
    }
    case 'REMOVE_PLAYHEAD': {
      const newState = Object.assign({}, state);
      delete newState[action.id];
      return newState;
    }
    case 'SET_PLAYHEAD_POINTS': {
      return action.heads;
    }
    default:
      return state;
  }
}
